<template>
  <div class="g-sdk"></div>
</template>

<script>
import global from "./Global";

// @@@ appId:super_app
// @@@ productId:76541e76ecb36a74
// @@@ deviceName:objectTest
// @@@ deviceKey:46a273c697caa639
// @@@ sname:29c104c05f57

var product_id = "1aed34bbd441c5ba"; //业务方申请

var serviceAppId = "super_app";
var serviceName = "87db57f25cf4";

var _godsee;
var TOB_STATUS;
var REQ_TYPE;

var liveList = {};
var playerList = {};
var waitTimer = {};

export default {
  name: "live",
  data() {
    return {};
  },
  mounted() {
    this.initSDK();
  },
  computed: {},
  methods: {
    openLive(sn, channel_no, data, containerId, box_sn) {
      this.stopLive(sn, channel_no, box_sn);
      var key;
      var sn_ = sn;
      if (box_sn && box_sn != "" && box_sn != "undefined") {
        sn_ = box_sn;
      }
      if (!liveList[sn_]) {
        liveList[sn_] = {};
      }
      if (data && data.key) {
        key = data.key;
        this.updateKey(sn_, data.key);
        liveList[sn_][key] = data.key;
      } else {
        liveList[sn_][key] = null;
      }
      liveList[sn_][channel_no] = {
        box_sn: box_sn,
        containerId: containerId,
        channel_no: channel_no
      };
      if (!data) {
        data = { sn: sn_ };
      } else {
        data.sn = sn_;
      }
      this.openStream(data, channel_no, 1);
      this.msg("直播初始化，SN：" + sn_ + "_通道号：" + channel_no, "success");
    },
    init() {
      if (liveList) {
        for (var sn in liveList) {
          this.stopLive(sn, -1);
        }
        liveList = {};
        for (var sn in waitTimer) {
          if (waitTimer[sn]) {
            for (var cl in waitTimer[sn]) {
              if (cl) {
                clearInterval(waitTimer[sn][cl]);
              }
            }
          }
        }
        waitTimer = {};
      }
    },
    stopLive(sn, channel_no = -1, box_sn) {
      // return false; // 新增机房 tracker报不在线处理
      var sn_ = sn;
      if (box_sn && box_sn != "" && box_sn != "undefined") {
        sn_ = box_sn;
      }
      if (waitTimer[sn_]) {
        if (channel_no == -1) {
          for (var cl in waitTimer[sn_]) {
            if (cl) {
              clearInterval(waitTimer[sn_][cl]);
            }
          }
        } else {
          clearInterval(waitTimer[sn_][channel_no]);
        }
      }
      if (liveList[sn_]) {
        if (_godsee) {
          _godsee.stopPlay(sn_, channel_no);
        }
        var box = liveList[sn_];
        if (channel_no == -1) {
          liveList[sn_] = {};
        } else {
          liveList[sn_][channel_no] = null;
        }
      }
      if (playerList[sn_]) {
        var player = playerList[sn_];
        if (channel_no == -1) {
          for (var c in player) {
            if (player[c]) {
              $("#" + player[c].cont_Id).css({ background: "0" });
              player[c].destroy();
              player[c] = null;
            }
          }
          playerList[sn] = null;
        } else {
          if (player && player[channel_no]) {
            $("#" + player[channel_no].cont_Id).css({ background: "0" });
            player[channel_no].destroy();
            player[channel_no] = null;
          }
        }
      }
    },

    //初始化直播播放器
    initLivePlayer(sn, channel_no = 1, id, key) {
      if (!playerList[sn]) {
        playerList[sn] = {};
      }

      if (playerList[sn][channel_no]) {
        playerList[sn][channel_no].destroy();
        playerList[sn][channel_no] = null;
      }
      var playerData = {
        container: "#" + id,
        src: this.getPlayUrlByParam(sn, channel_no),
        isLive: true,
        isHLS: false,
        keyType: 0,
        volume: 1,
        // renderType: "all",
        hasAudio: false,
        hasVideo: true,
        autoplay: true,
        minDecoderBufferSize: 128 * 1024,
        waitingYuvNum: 1,
        waitingPcmDur: 50,
        waitingProbation: 500,
        delayTimeLimit: 1000,
        lowpassFrequencyVal: 4500,
        rtwPlaybackRate: 2.131313,
        maxPlaybackRate: 2,
        yuvRenderDelay: -20,
        resample: 1
      };
      var logLevel = this.$route.query.logLevel;
      playerData.logLevel = logLevel || 0;
      //   var player = new window.QhwwPlayer(playerData);
      var player = flvjs.createPlayer(playerData);
      player.sn = sn;
      player.channel_no = channel_no;
      player.cont_Id = id;
      var that = this;
      player.on("error", function(e, a, c) {
        console.log("【播放器】播放异常，重新开始播放: " + sn, e, a, c);
        // alert('设备：' + sn + '异常，未能获取直播数据');
        if (a && a.target) {
          var sn = a.target.sn;
          var channel_no = a.target.channel_no;
          that.stopLive(sn, channel_no);
        }
      });
      if (key) {
        player[player.__mmk].setPlayerProps("liveList", key);
      }

      player.play().then(() => {});

      playerList[sn][channel_no] = player;
    },
    initSDK() {
      if (_godsee) {
        console.log("_godsee init", _godsee);
        return;
      }
      var option = {
        userId: "360user" + Math.floor(Math.random() * 100000 + 10000000), //**** userId中不能包含下划线(_)
        serviceAppId: serviceAppId,
        serviceName: serviceName,
        domain: "http://flvmonitor.iot.360.cn",
        online: 0,
        log: 2
      };
      _godsee = window.Signalling(option);

      TOB_STATUS = _godsee.CONFIG_STATUS;
      REQ_TYPE = _godsee.CONFIG_REQ_TYPE;

      //侦听SDK事件
      _godsee.on(TOB_STATUS.status, data => {
        if (!data || !data.type) {
          return;
        }
        switch (data.type) {
          case TOB_STATUS.type.connectStatus:
            //长连状态
            if (data.param.newVal == "connected") {
              //侦听到此状态，表示长连连接成功，之后进行开流等操作
              //TODO: 业务流程
              //准备就绪，开始获取秘钥
              //开流并建立心跳
              // sendTimeLineRequest(sn_);
              // 停止推流测试
              // setTimeout(function () {
              //     //channel_no: 通道号，若需要停止全部设备，channel_no传-1
              //     //如果什么都不传，关闭所有设备
              //     //传sn和-1，关闭sn设备的所有通道
              //     //传sn+channel，关闭指定通道
              //     _godsee.stopPlay(sn_);
              // }, 20000);
            }
            break;
          case TOB_STATUS.type.disconnect:
            //TODO:长连断开，尝试重连或销毁
            break;
          case TOB_STATUS.type.recordTimeline:
            //请求卡录时间轴结果
            //时间轴结果保存在【data.param.maskArray】中
            let list = data.param.maskArray;
            timelines = [];
            for (let i = 0; i < list.length; i++) {
              let t = list[i];
              let s = parseFloat(t.start);
              let e = parseFloat(t.duration);
              timelines.push({ start: s, end: e });
            }
            break;
          case TOB_STATUS.type.recordSeek:
            //获取卡录数据后，seek到某一个时间段开始播放
            break;
          case TOB_STATUS.type.recordSpeed:
            //卡录倍速设置成功
            break;
          case TOB_STATUS.type.setDevice:
            //固件设置
            if (data.param.errorCode == 0) {
              var key = data.param.key;
              if (key == DEVICE_DIRECTION.format) {
                //1、格式化指令接收成功
                //2、可以开始轮巡获取sd卡格式化进度了
              } else {
                //上下左右或复位等，操控固件设备的反馈
              }
              //TODO:提示成功
            } else {
              //TODO:提示失败
            }
            break;
          case TOB_STATUS.type.relaySuccess:
            //直播或卡录的开流成功
            var sn = data.param.sn;
            var type = data.param.type;
            var channel_no = data.param.channel_no;

            if (!liveList || !liveList[sn] || !liveList[sn][channel_no]) {
              console.log("livelist", sn, channel_no);
              return;
            }
            var containerId = liveList[sn][channel_no].containerId;
            $("#" + containerId).css({
              background:
                "#0e1e2f url(https://p4.ssl.qhimg.com/t019004f9f79543a527.gif) no-repeat center",
              "background-size": "200px 150px"
            });
            this.msg(
              "开流成功，SN：" + sn + "_通道号：" + channel_no,
              "success"
            );
            var key = liveList[sn].key;
            if (!waitTimer[sn]) {
              waitTimer[sn] = {};
            }
            waitTimer[sn][channel_no] = setTimeout(() => {
              this.streamPubSuccess(sn, channel_no, containerId, key);
            }, 2500);

            break;
          case TOB_STATUS.type.pubStream:
            //固件有推流
            var sn = data.param.sn;
            var type = data.param.type;
            var channel_no = data.param.channel_no;
            clearTimeout(waitTimer[sn][channel_no]);
            if (!liveList || !liveList[sn] || !liveList[sn][channel_no]) {
              console.log("livelist", sn, channel_no);
              return;
            }
            var containerId = liveList[sn][channel_no].containerId;
            this.streamPubSuccess(sn, channel_no, containerId, key);
            break;
          case TOB_STATUS.type.relayError:
            //直播或卡录的开流失败
            var sn = data.param.sn;
            var channel_no = data.param.channel_no;
            console.log("relayError", data.param);
            this.msg("开流失败，SN：" + sn + "_通道号：" + channel_no, "error");
            break;
          case TOB_STATUS.type.licenseError:
            //license认证失败,开流失败
            break;
          case TOB_STATUS.type.error:
            console.log("error", data.param);
            this.msg(
              data.param.msg +
                "，SN：" +
                data.param.sn +
                "_通道号：" +
                channel_no,
              "error"
            );
            break;
        }
      });
    },

    streamPubSuccess(sn, channel_no, containerId, key) {
      $("#" + containerId).css({ background: "0" });
      this.initLivePlayer(sn, channel_no, containerId, key);
      this.msg(
        "开始获取CDN资源，SN：" + sn + "_通道号：" + channel_no,
        "success"
      );
      console.log("开始加载cdn资源", new Date().getTime());
    },
    //开流并建立心跳
    openStream(data, channel_no = 1, bitrate = 1) {
      var param = {
        sn: data.sn,
        token: "",
        channel_no: channel_no,
        bitrate: bitrate,
        product_id: product_id,
        longconnect: "tcp"
      };
      if (data.hasOwnProperty("authorization")) {
        param.authorization = data.authorization;
      }
      if (data.hasOwnProperty("authTime")) {
        param.authoauthTimerization = data.authTime;
      }
      if (data.hasOwnProperty("randNum")) {
        param.randNum = data.randNum;
      }
      _godsee.startLive(param);
    },
    updateKey(sn, key) {
      var data = {
        sn: sn,
        keys: key
      };
      if (!_godsee) return;
      _godsee.updateKey(data);
    },
    getPlayUrlByParam(sn, channelno) {
      let param = {
        sn: sn, //设备sn
        channelno: channelno, //通道号:与消息通道必须一致
        resolution: 1 //清晰度 01：超清，02：高清，03标清
      };
      let url = _godsee.getPlayUrl(param);
      if (!url || url == "") {
        return null;
      }
      return url;
    },
    msg(text, type) {
      this.$msg.destroy();
      if (type == "success") {
        this.$msg.success(text);
      } else if (type == "error") {
        this.$msg.error(text);
      } else if (type == "info") {
        this.$msg.info(text);
      }
    }
  },
  components: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/utils/sdk.vue